export const API_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_API || ""
        : "http://localhost:4006";

export async function apiFetch(endpoint, options = {}) {
    const token = localStorage.getItem("epr_token");
    const isFormData = options.isFormData || options.body instanceof FormData;
    const headers = {
        // Don't set Content-Type for FormData — browser sets it with the correct boundary
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {}),
    };
    const { isFormData: _removed, ...fetchOptions } = options;
    const res = await fetch(`${API_BASE}${endpoint}`, {
        credentials: "include",
        ...fetchOptions,
        headers,
    });
    // If token is missing, expired or invalid — fire a global event so the
    // app can redirect to login without each caller needing to handle it.
    // IMPORTANT: Only fire for true token/auth failures from the middleware,
    // NOT for domain 401s like "wrong password" or "incorrect OTP" which
    // also use 401 but should be handled by the caller, not trigger logout.
    if (res.status === 401) {
        const cloned401 = res.clone();
        cloned401.json().then(d => {
            // Token-level failures from auth middleware have these specific messages
            const tokenFailMessages = [
                "Authentication required.",
                "Account not found or deactivated.",
                "Session expired — please log in again.",
                "Invalid authentication token.",
                "Not authenticated.",
            ];
            if (!d || tokenFailMessages.includes(d.message) || d.code === "TOKEN_EXPIRED") {
                localStorage.removeItem("epr_token");
                window.dispatchEvent(new CustomEvent("epr:unauthorized"));
            }
            // All other 401s (wrong password, wrong OTP, etc.) are domain errors
            // — let the caller's own error handling deal with them.
        }).catch(() => {
            // If we can't parse the body, safe to assume token failure
            localStorage.removeItem("epr_token");
            window.dispatchEvent(new CustomEvent("epr:unauthorized"));
        });
    }
    // If server blocks action because password reset is required — notify app
    // without logging the user out (they need to stay in to change it).
    if (res.status === 403) {
        const cloned = res.clone();
        cloned.json().then(d => {
            if (d && d.code === "PASSWORD_RESET_REQUIRED") {
                window.dispatchEvent(new CustomEvent("epr:password-reset-required"));
            }
        }).catch(() => { });
    }
    return res;
}